import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography, createStyles, Grid, Divider, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { ISignup, emptySignup } from '../../../models/users';
import { toastr } from 'react-redux-toastr';
import { useParams } from 'react-router-dom';
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import IntlTelInput, { CountryData } from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { Alert } from '@material-ui/lab';
import AuthLayout from '../auth-layout';
import { NavigateBefore } from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
// import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import { InvitationCodeEnum } from '../../../enum/signup/invitation-code-enum';
import { IAppSettingsDto } from '../../../models/common';
import { handleGetInviteCode } from '../../../shared/functions/common';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'table',
      height: '100%',
      position: 'absolute',
      overflow: 'hidden',
      width: '100%',
      backgroundImage: 'url(' + `${process.env.PUBLIC_URL}/login-bg.jpg` + ')',
      backgroundSize: '1920px 1080px',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'black',
      backgroundPosition: 'top center',
      paddingBottom: '4rem',
    },

    textPadding: {
      paddingTop: '8px',
      paddingBottom: '10px',
    },
    tabPanel: {
      display: 'flex',
      textAlign: 'center',
      padding: '0px',
      justifyContent: 'center',
    },
    hidden: {
      display: 'none!important',
    },
    bottomBtnContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    successGrid: {
      marginTop: '0px',
      textAlign: 'center',
    },
    alert: {
      marginTop: '10px',
    },
    limitations: {
      display: 'inline-flex',
      textAlign: 'left',
    },
    alertTitle: {
      width: '100%',
      fontSize: '1.1rem',
      '& .MuiAlert-message': {
        width: '100%',
      },
      '& .MuiAlert-icon': {
        display: 'none',
      },
    },
    fwTextCenter: {
      width: ' 100%',
      textAlign: 'center',
      marginBottom: '10px',
    },
    successTextCenter: {
      width: '100%',
      color: 'rgb(199, 167, 99)',
      textAlign: 'center',
    },
    fw: {
      width: ' 100%',
    },
    UnLimitedOption: {
      fontSize: '20px',
      color: 'green',
      marginRight: '4px',
      textAlign: 'left',
    },
    LimitedOption: {
      fontSize: '15px',
      color: 'orange',
      marginRight: '4px',
    },
    buttonContinue: {
      backgroundColor: '#4caf50 !important',
      color: 'white !important',
      '&:hover': {
        backgroundColor: '#0080005c !important',
        color: 'white !important',
      },
    },
    noContinueButton: {
      color: 'orange !important',
      border: '1px solid #ffa50045',
    },
    divCenter: {
      marginBottom: '1rem',
      borderRadius: '5px',
      padding: '.5rem',
      width: '90%',
      margin: 'auto',
      textAlign: 'center',
    },
    orangeBox: {
      marginBottom: '1rem',
      borderRadius: '5px',
      padding: '.5rem',
      width: '90%',
      margin: 'auto',
      textAlign: 'center',
      border: '1px solid orange',
    },
    greenBox: {
      marginBottom: '1rem',
      border: '1px solid green',
      borderRadius: '5px',
      padding: '.5rem',
    },
    textPoints: {
      fontSize: '0.75rem !important',
    },
    successText: {
      textAlign: 'center',
      width: '100%',
      marginBottom: '1rem',
    },
    loginButton: {
      marginBottom: '1.5rem',
      paddingLeft: 0,
    },
  }),
);

export interface ExternalProps {
  app_settings: IAppSettingsDto;
  is_credit: boolean;
  is_verified: boolean;
  isLoading: boolean;
  request_default_invite_code: boolean;
  shareableUrl: string | null;
  show_player_profile_settings_bonus: boolean;
  signupSuccess: boolean;
  token: string | null;
  username: string | null;
}
export interface ExternalActionProps {
  inviteAction: (code: string) => void;
  signupAction: (signup: ISignup) => void;
}
export const SignupPage = (props: ExternalActionProps & ExternalProps) => {
  const {
    app_settings,
    inviteAction,
    isLoading,
    is_credit,
    is_verified,
    request_default_invite_code,
    // shareableUrl,
    show_player_profile_settings_bonus,
    signupAction,
    signupSuccess,
    token,
    username,
  } = props;
  const { code } = useParams<any>();
  const classes = useStyles();
  const [ntab, setNtab] = useState(1);
  const [selected, setSelected] = useState({
    ...emptySignup,
    inviter_code: (code ?? '').toString().toLowerCase().trim() == InvitationCodeEnum.DEFAULT.toString().toLowerCase().trim() ? '' : code,
  });
  const [disabled, setDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [phone, setPhone] = useState<string>('');
  const [phoneFullNumber, setPhoneFullNumber] = useState<string>('');
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(false);

  useEffect(() => {
    if (token !== null && signupSuccess) {
      setNtab(2);
    }
  }, [token]);

  useEffect(() => {
    if (request_default_invite_code) {
      setOpenDialog(true);
    }
  }, [request_default_invite_code]);

  const handleResponse = (result: boolean) => {
    setSelected({ ...selected, default_invite_code: result });
    if (result) {
      signupAction({
        ...selected,
        default_invite_code: result,
        phone: phone,
        fullPhone: phoneFullNumber,
        inviter_code: selected.inviter_code.trim().length == 0 ? handleGetInviteCode() : selected.inviter_code,
      });
    }
    setOpenDialog(false);
  };

  useEffect(() => {
    if ((code ?? '').toString().toLowerCase().trim() != InvitationCodeEnum.DEFAULT.toString().toLowerCase().trim()) {
      inviteAction(code);
    }
  }, []);

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => {
        return response.json();
      })
      .then(res => {
        setSelected({
          ...selected,
          ip: res.ip,
        });
      })
      .catch(err => console.error('Problem fetching my IP', err));
  }, []);

  if (localStorage.getItem('fpjs') == null) {
    FingerprintJS.load({ token: 'nvoiB2OqFxGoBIg53MC6' })
      .then(fp => fp.get())
      .then(result => {
        localStorage.setItem('fpjs', result.visitorId);
      })
      .catch(ex => {
        console.log(ex);
        const userId = btoa('signup:' + new Date().getTime());
        localStorage.setItem('fpjs', userId);
      });
  }

  const validation = () => {
    if (selected.password != selected.password_confirmation) {
      toastr.error('Error', 'Password and Confirmation Password did not match');
      setDisabled(false);
      return false;
    }
    if (selected.phone == '') {
      toastr.error('Error', 'Please enter a valid phone number.');
      setDisabled(false);
      return false;
    }
    if (!selected.agreed) {
      toastr.error('Error', 'Please agree to the terms and conditions.');
      setDisabled(false);
      return false;
    }
    setDisabled(true);
    return true;
  };

  const SignUpProcess = () => {
    if (validation()) {
      signupAction({
        ...selected,
        phone: phone,
        fullPhone: phoneFullNumber,
        inviter_code:
          selected.inviter_code.trim().length == 0 ||
          (selected.inviter_code ?? '').toString().toLowerCase().trim() == InvitationCodeEnum.DEFAULT.toString().toLowerCase().trim()
            ? handleGetInviteCode()
            : selected.inviter_code,
      });
    }
  };

  const handhler = (isValid: boolean, value: string, selectedCountryData: CountryData, fullNumber: string) => {
    setPhone(value.replace(/\D/g, ''));
    setPhoneFullNumber(fullNumber);
    setIsValidPhoneNumber(isValid);

    setSelected({
      ...selected,
      phone: value.replace(/\D/g, ''),
      countryData: selectedCountryData,
    });
  };

  return (
    <AuthLayout isLoading={isLoading} app_settings={app_settings}>
      <div>
        <Grid container alignContent='center' className={clsx(classes.successGrid, { [classes.hidden]: signupSuccess })}>
          <Button
            color='default'
            onClick={() => {
              window.parent.postMessage({ action: 'closeWindow' }, '*');
            }}
            className={classes.loginButton}
          >
            <NavigateBefore /> Exit
          </Button>

          <Grid item xs={12} className={clsx(classes.tabPanel, { [classes.hidden]: ntab != 1 })}>
            <Grid item xs={12} style={{ textAlign: 'left' }}>
              <Divider style={{ marginBottom: '1rem' }} />

              <Typography variant={'h6'} gutterBottom>
                Contact Information
              </Typography>
              <form
                id='signupForm'
                onSubmit={e => {
                  e.preventDefault();
                  SignUpProcess();
                }}
              >
                <div className='IntTelInputContainer'>
                  <IntlTelInput
                    containerClassName='intl-tel-input'
                    inputClassName='MuiInputBase-input'
                    defaultCountry={emptySignup.countryData.iso2}
                    geoIpLookup={event => {
                      console.log(event);
                    }}
                    onPhoneNumberChange={handhler}
                    format={true}
                    telInputProps={{
                      required: true,
                      type: 'number',
                    }}
                    value={phone}
                  />
                  {phone && phone.trim().length > 0 && (
                    <>
                      <Alert severity={`${isValidPhoneNumber ? 'success' : 'error'}`} className={classes.alert}>
                        Phone number in E.164 format: {phoneFullNumber}
                        <br />
                      </Alert>
                    </>
                  )}
                </div>

                <TextField
                  fullWidth
                  variant='filled'
                  placeholder='Email'
                  required
                  type='email'
                  label='Email'
                  size='small'
                  className={classes.textPadding}
                  value={selected.email}
                  onChange={e =>
                    setSelected({
                      ...selected,
                      email: e.target.value,
                    })
                  }
                />

                <TextField
                  fullWidth
                  variant='filled'
                  placeholder='First Name'
                  required
                  type='text'
                  label='First Name'
                  size='small'
                  className={classes.textPadding}
                  value={selected.first_name}
                  onChange={e =>
                    setSelected({
                      ...selected,
                      first_name: e.target.value,
                    })
                  }
                />

                <TextField
                  fullWidth
                  variant='filled'
                  placeholder='Last Name'
                  type='text'
                  label='Last Name'
                  size='small'
                  className={classes.textPadding}
                  value={selected.last_name}
                  onChange={e =>
                    setSelected({
                      ...selected,
                      last_name: e.target.value,
                    })
                  }
                />

                <TextField
                  fullWidth
                  variant='filled'
                  placeholder='Password'
                  type='password'
                  required
                  label='Password'
                  size='small'
                  value={selected.password}
                  onChange={e =>
                    setSelected({
                      ...selected,
                      password: e.target.value,
                    })
                  }
                  className={classes.textPadding}
                  helperText={'Password must be 6-10 characters with letters and numbers only.'}
                />

                <TextField
                  fullWidth
                  variant='filled'
                  placeholder='Confirm Password'
                  label='Confirm Password'
                  size='small'
                  className={classes.textPadding}
                  type='password'
                  required
                  value={selected.password_confirmation}
                  onChange={e =>
                    setSelected({
                      ...selected,
                      password_confirmation: e.target.value,
                    })
                  }
                />

                <TextField
                  fullWidth
                  variant='filled'
                  label={`${
                    (code ?? '').toString().toLowerCase().trim() == InvitationCodeEnum.DEFAULT.toString().toLowerCase().trim()
                      ? 'If you have an invite link, please enter it'
                      : 'Invite Code'
                  }`}
                  placeholder='Invite Code'
                  className={classes.textPadding}
                  value={selected.inviter_code}
                  size='small'
                  onChange={e =>
                    setSelected({
                      ...selected,
                      inviter_code: e.target.value,
                    })
                  }
                  style={{ marginBottom: '.75rem' }}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={e => {
                        setSelected({
                          ...selected,
                          agreed: e.target.checked,
                        });
                      }}
                    />
                  }
                  labelPlacement={'end'}
                  label={
                    <small>
                      By checking this box, I agree to receive text messages and agree to the terms and conditions outlined by VIPClub
                    </small>
                  }
                  style={{ marginBottom: '1rem', fontSize: '.5rem' }}
                />
              </form>
            </Grid>
          </Grid>
          <Grid item xs={12} className={clsx(classes.bottomBtnContainer, { [classes.hidden]: ntab != 1 })}>
            <Button variant='contained' type='submit' form='signupForm' color='primary' disabled={disabled && isLoading} fullWidth>
              Next
            </Button>
          </Grid>
        </Grid>
        <Grid container className={clsx(classes.tabPanel, { [classes.hidden]: ntab != 2 })}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Alert
              severity={`${is_verified == true ? 'success' : 'warning'}`}
              variant={'filled'}
              style={{ marginBottom: '1rem' }}
              className={classes.alertTitle}
            >
              Your account has been created
              {/* {is_credit == true
                ? 'Your account has been created'
                : is_verified == false
                ? 'Identity Verification'
                : 'Your account has been verified'} */}
              <br />
            </Alert>

            {is_verified == false ? (
              <>
                <Grid container className={classes.greenBox} spacing={1}>
                  <Grid item xs={12} className={classes.limitations}>
                    <Typography className={classes.fwTextCenter} variant={'body1'}>
                      Remember to verify your identity to enjoy the full VIP Experience
                    </Typography>
                  </Grid>

                  <Divider color={'green'}></Divider>

                  <Grid item xs={6} className={classes.limitations}>
                    <CheckCircleOutlineIcon className={classes.UnLimitedOption} />
                    <Typography variant={'body2'}>Wide Variety of Deposit Methods</Typography>
                  </Grid>

                  <Grid item xs={6} className={classes.limitations}>
                    <CheckCircleOutlineIcon className={classes.UnLimitedOption} />
                    <Typography variant={'body2'}>Instant Withdrawals</Typography>
                  </Grid>

                  <Grid item xs={6} className={classes.limitations}>
                    <CheckCircleOutlineIcon className={classes.UnLimitedOption} />
                    <Typography variant={'body2'}>Higher Wager Limits</Typography>
                  </Grid>

                  <Grid item xs={6} className={classes.limitations}>
                    <CheckCircleOutlineIcon className={classes.UnLimitedOption} />
                    <Typography variant={'body2'}>Best Bonuses and Low Rollovers</Typography>
                  </Grid>

                  {show_player_profile_settings_bonus && (
                    <Grid item xs={6} className={classes.limitations}>
                      <CheckCircleOutlineIcon className={classes.UnLimitedOption} />
                      <Typography variant={'body2'}>New Non-Deposit Bonus</Typography>
                    </Grid>
                  )}
                </Grid>

                <Grid container>
                  {/* <Grid item xs={12}>
                    <Button
                      variant='contained'
                      type='button'
                      form='signupForm'
                      color='primary'
                      className={classes.buttonContinue}
                      style={{ marginTop: '1rem', fontSize: '0.75rem' }}
                      fullWidth
                      disabled={shareableUrl == null ? true : false}
                      onClick={() => {
                        if (shareableUrl) {
                          window.open(shareableUrl);
                          setTimeout(() => {
                            window.parent.postMessage({ action: 'closeWindow', code: token }, '*');
                          }, 1000);
                        }
                      }}
                    >
                      Yes, continue to verify my identity
                    </Button>
                  </Grid> */}
                  <Grid item xs={12}>
                    <Button
                      variant='outlined'
                      type='button'
                      form='signupForm'
                      color='primary'
                      fullWidth
                      className={classes.buttonContinue}
                      style={{ marginTop: '1rem', marginBottom: '1rem', fontSize: '0.75rem' }}
                      onClick={() => {
                        window.parent.postMessage({ action: 'closeWindow', code: token }, '*');
                      }}
                    >
                      Continue
                    </Button>
                  </Grid>
                </Grid>

                {/* <div className={classes.divCenter}>
                  <Typography className={classes.fwTextCenter} variant={'subtitle2'}>
                    Failure to verify identity will only allow your account to the following options
                  </Typography>
                </div> */}

                {/* <Grid container className={classes.orangeBox} spacing={1}>
                  <Grid item xs={12} className={classes.limitations}>
                    <Typography className={classes.fwTextCenter} variant={'body2'}>
                      Limited Access
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} className={classes.limitations}>
                    <ErrorOutlineOutlinedIcon className={classes.LimitedOption} />
                    <Typography className={classes.textPoints} variant={'subtitle2'}>
                      Bitcoin Deposit Only
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} className={classes.limitations}>
                    <ErrorOutlineOutlinedIcon className={classes.LimitedOption} />
                    <Typography className={classes.textPoints} variant={'subtitle2'}>
                      Bitcoin Withdrawals Only
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} className={classes.limitations}>
                    <ErrorOutlineOutlinedIcon className={classes.LimitedOption} />
                    <Typography className={classes.textPoints} variant={'subtitle2'}>
                      $250 Wager Limit
                    </Typography>
                  </Grid>
                </Grid> */}
              </>
            ) : (
              <>
                <div className={classes.divCenter}>
                  <Typography className={classes.successText} variant={'body1'}>
                    Welcome to VIP CLUB!
                  </Typography>
                  <br />
                  {is_credit == false && username && (
                    <Typography className={classes.fwTextCenter} variant={'h6'}>
                      {username}
                    </Typography>
                  )}
                  <Typography className={`${is_credit == true ? classes.fwTextCenter : classes.successTextCenter}`} variant={'subtitle2'}>
                    {is_credit == true ? (
                      <>{`Account Number ${username ?? ''}`}</>
                    ) : (
                      <>{`Your account is fully verified and you can now enjoy the full VIP Experience.`}</>
                    )}
                  </Typography>
                </div>

                <Grid container justifyContent='center'>
                  <Grid item xs={6}>
                    <Button
                      variant='contained'
                      type='button'
                      form='signupForm'
                      color='primary'
                      className={classes.buttonContinue}
                      style={{ marginTop: '1rem', fontSize: '0.75rem' }}
                      fullWidth
                      onClick={() => {
                        location.reload();
                      }}
                    >
                      Log In
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>

        {openDialog && (
          <Dialog
            fullWidth
            maxWidth='xs'
            open={openDialog}
            onClose={() => {
              setOpenDialog(false);
            }}
            aria-labelledby='max-width-dialog-title'
          >
            <DialogContent>
              <Typography>The invitation code is not valid, Do you want to continue the signup process?</Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant='contained'
                color='primary'
                onClick={() => {
                  handleResponse(true);
                }}
              >
                Ok
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={() => {
                  handleResponse(false);
                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </AuthLayout>
  );
};
